import React from 'react';
import { useAudioPlayer } from './AudioPlayerProvider';
import './AudioPlayer.scss';

const PlaySvg = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 5.00004C6 4.22825 6.83721 3.74738 7.50387 4.13626L19.5039 11.1363C20.1654 11.5221 20.1654 12.4779 19.5039 12.8638L7.50387 19.8638C6.83721 20.2527 6 19.7718 6 19V5.00004Z"
            fill="white"
        />
    </svg>
);

const PauseSvg = () => (
    <svg
        style={{ marginTop: '-3px', marginLeft: '-4px' }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 7C9.67157 7 9 7.67157 9 8.5V19.5C9 20.3284 9.67157 21 10.5 21C11.3284 21 12 20.3284 12 19.5V8.5C12 7.67157 11.3284 7 10.5 7ZM17.5 7C16.6716 7 16 7.67157 16 8.5V19.5C16 20.3284 16.6716 21 17.5 21C18.3284 21 19 20.3284 19 19.5V8.5C19 7.67157 18.3284 7 17.5 7Z"
            fill="white"
        />
    </svg>
);

export const Play = () => {
    const { onPlayClick, playing } = useAudioPlayer();

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                position: 'absolute',
                left: '0px',
            }}
        >
            <div
                className="play-button"
                style={{
                    width: '28px',
                    height: '28px',
                    marginRight: '16px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                tabIndex={0}
                role="button"
                aria-label="play"
                onClick={onPlayClick}
                onKeyPress={onPlayClick}
            >
                {!playing ? <PlaySvg /> : <PauseSvg />}
            </div>
        </div>
    );
};
